@use '@css/variables';

.faq {

  column-count: 1;
  column-gap: 2em;


  .group {
    break-inside: avoid;
  }

  .question {
    margin: 0 0 1em 0;
    background: #FFFFFF;
    border: 1px solid #D5CFBD;
    border-radius: 6px;
    clear: both;

    h4 {
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;
      padding: 24px 65px 24px 24px;

      //font-size: var(--base-font-size);
      //font-family: var(--font-family-body);
      //font-weight: bold;

      &:after {
        content: "\2b";
        font-family: var(--font-family-fontawesome);
        position: absolute;
        right: 15px;
        background-color: var(--beigelight);
        color: var(--beigedarker);
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.3s;


      }
    }

    div {
      //padding: 0 24px 24px 24px;
      //max-height: 100vh;


      max-height: 0;
      overflow: hidden;
      padding: 0 24px;
      transition: 0.3s;
    }

    &.open h4:after {
      transform: rotate(45deg);
    }

    &.open div {
      padding: 0 24px 24px 24px;
      max-height: 100vh;
    }
  }
}

@media only screen and (min-width: variables.$md-breakpoint) {
  .faq:not(.single) {
    column-count: 2;
  }
}